import { alpha } from "@mui/material/styles";
import { listClasses } from "@mui/material/List";
import { paperClasses } from "@mui/material/Paper";
import { buttonClasses } from "@mui/material/Button";
import { listItemIconClasses } from "@mui/material/ListItemIcon";
import { tablePaginationClasses } from "@mui/material/TablePagination";
//
import { paper } from "../../css";
// ----------------------------------------------------------------------
export function dataGrid(theme) {
    const paperStyles = paper({ theme, dropdown: true });
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderWidth: 0,
                    borderRadius: "16px",
                    backgroundColor: "white",
                    boxShadow: "0px 12px 24px -4px #919EAB1F,0px 0px 2px 0px #919EAB33",
                    "& .MuiDataGrid-scrollbarFiller": {
                        backgroundColor: "#F4F6F8 !important", // <-- force transparent
                    },
                    "& .MuiDataGrid-filler > div": {
                        borderTop: "none !important",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        "&::-webkit-scrollbar": {
                            width: "6px",
                            height: "6px",
                            background: "transparent",
                            transition: "background-color 0.3s ease",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "transparent",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "transparent",
                            borderRadius: "3px",
                        },
                        "&::-webkit-scrollbar-thumb:vertical, &::-webkit-scrollbar-thumb:horizontal": {
                            transition: "background-color 0.3s ease-in-out",
                        },
                        "&:hover::-webkit-scrollbar-thumb": {
                            background: "rgba(0, 0, 0, 0.32)",
                        },
                        scrollbarWidth: "thin",
                        scrollbarColor: "transparent transparent",
                        "&:hover": {
                            scrollbarColor: "rgba(0, 0, 0, 0.32) transparent",
                        },
                    },
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: theme.palette.background.neutral,
                    },
                    "& .MuiDataGrid-cell": {
                        border: "none !important",
                    },
                    "& .MuiSvgIcon-root ": {
                        color: "rgba(69, 79, 91, 1)",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        backgroundColor: theme.palette.background.neutral,
                        fontWeight: "500 !important",
                        overflow: "visible !important",
                        fontSize: "14px !important",
                        color: theme.palette.tertiary[30],
                    },
                    [`& .${tablePaginationClasses.root}`]: {
                        borderTop: 0,
                        color: theme.palette.tertiary[40],
                        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                            color: theme.palette.tertiary[40],
                        },
                        "& .MuiIconButton-root": {
                            color: theme.palette.tertiary[40],
                            "& .MuiSvgIcon-root": {
                                color: theme.palette.tertiary[40],
                            },
                        },
                    },
                    [`& .${tablePaginationClasses.toolbar}`]: {
                        height: "40px",
                        color: theme.palette.tertiary[40],
                    },
                    "& .MuiDataGrid-row.Mui-selected": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.2),
                    },
                    "& .MuiDataGrid-withBorderColor": {
                        border: "1px solid transparent",
                    },
                },
                cell: {
                    borderBottom: `1px dashed transparent`,
                },
                selectedRowCount: {
                    whiteSpace: "nowrap",
                },
                columnSeparator: {
                    color: theme.palette.divider,
                    display: "none",
                },
                toolbarContainer: {
                    padding: theme.spacing(2),
                    borderBottom: `1px dashed ${theme.palette.divider}`,
                    height: "40px",
                    backgroundColor: theme.palette.background.neutral,
                },
                paper: Object.assign(Object.assign({}, paperStyles), { padding: 0 }),
                menu: {
                    [`& .${paperClasses.root}`]: Object.assign({}, paperStyles),
                    [`& .${listClasses.root}`]: {
                        padding: 0,
                        [`& .${listItemIconClasses.root}`]: {
                            minWidth: 0,
                            marginRight: theme.spacing(2),
                        },
                    },
                },
                panelHeader: {
                    padding: theme.spacing(2),
                },
                footerContainer: {
                    borderRadius: 8,
                    minHeight: 53,
                    background: theme.palette.background.neutral,
                    color: theme.palette.tertiary[40],
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                        color: theme.palette.tertiary[40],
                    },
                    "& .MuiIconButton-root": {
                        color: theme.palette.tertiary[40],
                        border: "none",
                        "& .MuiSvgIcon-root": {
                            color: theme.palette.tertiary[40],
                        },
                    },
                },
                panelFooter: {
                    padding: theme.spacing(2),
                    justifyContent: "flex-end",
                    borderTop: `dashed 1px transparent`,
                    [`& .${buttonClasses.root}`]: {
                        "&:first-of-type": {},
                        "&:last-of-type": {
                            marginLeft: theme.spacing(1.5),
                            color: theme.palette.background.paper,
                            backgroundColor: theme.palette.text.primary,
                        },
                    },
                },
                filterForm: {
                    padding: theme.spacing(2),
                    display: "flex",
                    alignItems: "center",
                    gap: theme.spacing(2),
                    "& .MuiDataGrid-filterFormDeleteIcon": {
                        order: 999,
                        marginLeft: "auto",
                        marginRight: 0,
                    },
                },
                filterFormColumnInput: {
                    display: "none !important",
                    visibility: "hidden !important",
                    width: 0,
                    margin: 0,
                    padding: 0,
                },
                filterFormOperatorInput: {
                    marginLeft: 0,
                },
                filterFormValueInput: {
                    marginLeft: 0,
                    flex: 1,
                    "& .MuiInputBase-root": {
                        borderRadius: "40px",
                        height: "45px",
                        padding: "12px 16px",
                    },
                },
            },
        },
    };
}
